import { Tenet } from "./listing";

interface Props {
  tenet: Tenet;
  index: number;
}

const Item = ({ tenet, index }: Props) => (
  <div className="max-w-6xl mx-auto px-4 sm:px-6 pb-16">
    <div className="flex flex-wrap -mx-2">
      <div className="lg:w-1/2 px-2 lg:pr-16 mb-6 lg:mb-0">
        <div className="flex">
          <h2>
            <span className="inline-flex text-brand-600 font-semibold items-center justify-center h-12 w-12 mr-2 border border-brand-900 rounded-full">
              {index + 1}
            </span>
          </h2>
          <h2 className="text-3xl font-semibold text-brand-600">
            {tenet.title}
          </h2>
        </div>
      </div>
      <div className="lg:w-1/2 px-2">{tenet.text}</div>
    </div>
  </div>
);

export default Item;
